import { useCallback, useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { cn, semanticClass, themeClass, themeSemantic } from '../theme/themeClasses';

/**
 * Hook for dynamic light/dark class selection in components.
 */
export function useThemeClasses() {
  const { isDark, theme } = useTheme();

  const tc = useCallback(
    (map, extra = '') => themeClass(isDark, map, extra),
    [isDark]
  );

  const sc = useCallback(
    (key, extra = '') => semanticClass(isDark, key, extra),
    [isDark]
  );

  return useMemo(
    () => ({
      isDark,
      theme,
      tc,
      sc,
      cn,
      semantic: themeSemantic,
    }),
    [isDark, theme, tc, sc]
  );
}
